import { create } from 'zustand';

interface TickerData {
  symbol: string;
  price: number;
  volume: number;
  volumeUSDT: number;
  change: number;
}

interface MultiTickerState {
  tickers: Record<string, TickerData>;
  connect: (symbols: string[]) => void;
}

export const useMultiTickerStore = create<MultiTickerState>((set) => {
  let socket: WebSocket | null = null;
  let currentSymbols: string[] = [];

  const connect = (symbols: string[]) => {
    const cleanSymbols = [...new Set(symbols)].sort();
    const cleanCurrent = [...currentSymbols].sort();
    if (JSON.stringify(cleanSymbols) === JSON.stringify(cleanCurrent)) return;

    currentSymbols = cleanSymbols;
    if (socket) socket.close();

    const streams = cleanSymbols.map((s) => `${s.toLowerCase()}@ticker`);
    const url = `wss://fstream.binance.com/stream?streams=${streams.join('/')}`;
    socket = new WebSocket(url);

    socket.onmessage = (event) => {
      const { data } = JSON.parse(event.data);
      const symbol = data?.s?.toLowerCase();
      const price = parseFloat(data?.c);
      const volume = parseFloat(data?.v);
      const change = parseFloat(data?.P);
      const volumeUSDT = parseFloat(data?.q);

      if (!symbol || isNaN(price) || isNaN(volume)) return;

      set((state) => ({
        tickers: {
          ...state.tickers,
          [symbol]: {
            symbol,
            price,
            volume,
            volumeUSDT,
            change,
          },
        },
      }));
    };

    socket.onerror = (e) => {
      console.error('Ticker WebSocket Error:', e);
    };
  };

  return {
    tickers: {},
    connect,
  };
});
